<template>
  <SlideIn :open="isOpen" heading="Sign In" @close="isOpen = false">
    <template #content>
      <SingleSignOn />
      <LoginForm @success="handleLoginSuccess" />
    </template>
  </SlideIn>
</template>

<script>
import { mapActions, mapState } from "vuex";

import LoginForm from "@/components/account/LoginForm.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import SlideIn from "@/components/SlideIn.vue";

export default {
  name: "SlideLogin",
  components: {
    LoginForm,
    SlideIn,
    SingleSignOn,
  },
  computed: {
    ...mapState("app", ["isSlideLoginOpen"]),
    ...mapState("auth", ["multipassAccount"]),
    isOpen: {
      get() {
        return this.isSlideLoginOpen;
      },
      set(value) {
        this.setSlideLogin(value);
      },
    },
  },
  methods: {
    ...mapActions("app", ["setSlideLogin"]),
    handleLoginSuccess() {
      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.sso-buttons {
  border-bottom: solid 1px rgba($color-dark, 0.5);
  margin: 0 -20px 40px;
  padding: 0 20px 40px;

  ::v-deep(.button) {
    &:first-child {
      margin: 0 0 10px 0;
    }
  }
}

.text {
  font-family: $heading-font-family;
  font-size: 12px;
  font-weight: 300;
  margin: 10px 0 30px 0;
}
</style>
